import {
  FETCH_UPCOMING_INTERVIEWS_SUCCESS,
  FETCH_UPCOMING_INTERVIEWS_REQUEST,
  FETCH_UPCOMING_INTERVIEWS_FAILURE,
} from "./actionType";

export const fetchUpcomingInterviewsRequest = (date) => ({
  type: FETCH_UPCOMING_INTERVIEWS_REQUEST,
  payload: date,
});

export const fetchUpcomingInterviewsSuccess = (data) => ({
  type: FETCH_UPCOMING_INTERVIEWS_SUCCESS,
  payload: data,
});

export const fetchUpcomingInterviewsFailure = (error) => ({
  type: FETCH_UPCOMING_INTERVIEWS_FAILURE,
  payload: error,
});
